export default "__VITE_ASSET__0210f1f1__"